import React, { useState } from "react";
import { Bar, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

function Anket() {
  const [anketler, setAnketler] = useState([
    {
      id: 1,
      question: "En sevdiğiniz renk nedir?",
      options: ["Kırmızı", "Mavi", "Yeşil", "Sarı"],
      results: [40, 60, 30, 20],
    },
    {
      id: 2,
      question: "Hangi mevsimi daha çok seviyorsunuz?",
      options: ["Yaz", "Kış", "İlkbahar", "Sonbahar"],
      results: [50, 30, 40, 20],
    },
    {
      id: 3,
      question: "Günde kaç saat uyuyorsunuz?",
      options: ["4-6 Saat", "6-8 Saat", "8-10 Saat", "10+ Saat"],
      results: [20, 50, 40, 10],
    },
  ]);

  const [selectedAnket, setSelectedAnket] = useState(null);
  const [addPopupVisible, setAddPopupVisible] = useState(false);
  const [newAnket, setNewAnket] = useState({
    question: "",
    options: ["", "", "", ""],
    results: [0, 0, 0, 0],
  });

  const renderChartData = (anket) => ({
    labels: anket.options,
    datasets: [
      {
        label: "Oy Sayısı",
        data: anket.results,
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#4BC0C0",
          "#9966FF",
        ],
        borderColor: "#fff",
        borderWidth: 1,
      },
    ],
  });

  // Yeni anket ekleme
  const handleAddAnket = () => {
    setAnketler((prev) => [
      ...prev,
      { ...newAnket, id: prev.length + 1 },
    ]);
    setNewAnket({
      question: "",
      options: ["", "", "", ""],
      results: [0, 0, 0, 0],
    });
    setAddPopupVisible(false);
  };

  return (
    <div className="min-h-screen bg-sky-100 p-8 shadow rounded">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Anket Sonuçları</h1>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          onClick={() => setAddPopupVisible(true)}
        >
          Yeni Anket Oluştur
        </button>
      </div>

      {/* Anket Tablosu */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white shadow rounded mb-8">
          <thead>
            <tr>
              <th className="px-6 py-3 border-b text-left text-sm font-medium text-gray-700">
                ID
              </th>
              <th className="px-6 py-3 border-b text-left text-sm font-medium text-gray-700">
                Soru
              </th>
              <th className="px-6 py-3 border-b text-left text-sm font-medium text-gray-700">
                Aksiyon
              </th>
            </tr>
          </thead>
          <tbody>
            {anketler.map((anket) => (
              <tr key={anket.id} className="hover:bg-gray-100">
                <td className="px-6 py-3 border-b text-sm text-gray-700">
                  {anket.id}
                </td>
                <td className="px-6 py-3 border-b text-sm text-gray-700">
                  {anket.question}
                </td>
                <td className="px-6 py-3 border-b text-sm text-blue-500">
                  <button
                    className="hover:underline"
                    onClick={() => setSelectedAnket(anket)}
                  >
                    Görüntüle
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Grafik Bölümü */}
      {selectedAnket && (
        <div className="bg-white p-6 rounded shadow-lg">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            {selectedAnket.question}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Bar Chart */}
            <div>
              <h3 className="text-lg font-semibold text-gray-600 mb-2">
                Bar Grafiği
              </h3>
              <Bar
                data={renderChartData(selectedAnket)}
                options={{
                  responsive: true,
                  plugins: {
                    legend: { position: "top" },
                    title: { display: true, text: "Anket Sonuçları" },
                  },
                }}
              />
            </div>
            {/* Pie Chart */}
            <div>
              <h3 className="text-lg font-semibold text-gray-600 mb-2">
                Pasta Grafiği
              </h3>
              <Pie
                data={renderChartData(selectedAnket)}
                options={{
                  responsive: true,
                  plugins: {
                    legend: { position: "top" },
                    title: { display: true, text: "Anket Dağılımı" },
                  },
                }}
              />
            </div>
          </div>
          <div className="flex justify-end mt-4">
            <button
              className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
              onClick={() => setSelectedAnket(null)}
            >
              Kapat
            </button>
          </div>
        </div>
      )}

      {/* Yeni Anket Ekle Popup */}
      {addPopupVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded shadow-lg w-96">
            <h2 className="text-xl font-bold text-gray-800 mb-4">
              Yeni Anket Oluştur
            </h2>
            <input
              type="text"
              className="w-full p-2 border rounded mb-4"
              placeholder="Soru"
              value={newAnket.question}
              onChange={(e) =>
                setNewAnket({ ...newAnket, question: e.target.value })
              }
            />
            {newAnket.options.map((option, index) => (
              <input
                key={index}
                type="text"
                className="w-full p-2 border rounded mb-2"
                placeholder={`Seçenek ${index + 1}`}
                value={option}
                onChange={(e) => {
                  const updatedOptions = [...newAnket.options];
                  updatedOptions[index] = e.target.value;
                  setNewAnket({ ...newAnket, options: updatedOptions });
                }}
              />
            ))}
            <div className="flex justify-between mt-4">
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                onClick={handleAddAnket}
              >
                Kaydet
              </button>
              <button
                className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                onClick={() => setAddPopupVisible(false)}
              >
                İptal
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Anket;
